import { render, staticRenderFns } from "./ApexoTableHeading.vue?vue&type=template&id=10535382&"
import script from "./ApexoTableHeading.vue?vue&type=script&lang=js&"
export * from "./ApexoTableHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports